module.exports = __webpack_public_path__ + "img/arrow-up-down.546fd8f6.svg";